import axiosConfig from "../../../../common/config/axiosConfig";
import {OfferUniverse} from "../../../../showcase/models/CartApiResponse";

export interface AddToCartParams {
    seoId: string;
    deviceEan?: string;
    withClientPrice: boolean;
}

export class MobileOffersCdsService {
    private static readonly API_URLS = {
        ADD_TO_CART_URL: '/api/mobile/add-to-cart',
    };

    static addToCartAndUpdateOffers(params: AddToCartParams): Promise<any> {
        const payload = {
            id: params.seoId,
            deviceEan: params.deviceEan || null,
            universe: OfferUniverse.MOBILE,
            withClientPrice: params.withClientPrice,
        }

        return axiosConfig.post(this.API_URLS.ADD_TO_CART_URL, payload, {
            headers: {
                'Content-Type': 'application/json',
                'token': document.body.dataset.token || ''
            }
        });
    }
}
